



export const MainContainer = ({ children }: { children: JSX.Element }) => {
    return (
       <div className="d-flex flex-column p-3" style={{ height: '100dvh',width:'100dvw' }}>
        {children}
       </div>
    );
    }